"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.sokTags = exports.generateSokTagSvg = exports.getCurrentTag = exports.getSokFillColor = void 0;
var react_1 = __importDefault(require("react"));
var seesignage_utils_1 = require("@seesignage/seesignage-utils");
var i18n_1 = __importDefault(require("../../../../translations/i18n"));
var sokTags = (_a = {},
    _a[seesignage_utils_1.ProductTags.organic] = { color: '#4E9101' },
    _a[seesignage_utils_1.ProductTags.local] = { color: '#FF8A00' },
    _a[seesignage_utils_1.ProductTags.discount] = { color: '#A30000' },
    _a[seesignage_utils_1.ProductTags.new] = { color: '#FFF200' },
    _a);
exports.sokTags = sokTags;
var getSokFillColor = function (tag) {
    var _a;
    if (tag === seesignage_utils_1.ProductTags.local && i18n_1.default.language === 'sv') {
        // special case for Åland's local tag
        return '#0060ae';
    }
    return (_a = sokTags[tag]) === null || _a === void 0 ? void 0 : _a.color;
};
exports.getSokFillColor = getSokFillColor;
/**
 * Get current visible tag
 */
var getCurrentTag = function (tags) {
    if (tags.includes(seesignage_utils_1.ProductTags.discount)) {
        return seesignage_utils_1.ProductTags.discount;
    }
    else if (tags.includes(seesignage_utils_1.ProductTags.local)) {
        return seesignage_utils_1.ProductTags.local;
    }
    else if (tags.includes(seesignage_utils_1.ProductTags.organic)) {
        return seesignage_utils_1.ProductTags.organic;
    }
    else if (tags.includes(seesignage_utils_1.ProductTags.new)) {
        return seesignage_utils_1.ProductTags.new;
    }
};
exports.getCurrentTag = getCurrentTag;
var portratTagContainerStyles = {
    position: 'absolute',
    right: '0px',
    top: '70px',
    fontSize: '30px',
    color: 'white',
    zIndex: 5,
    padding: '20px',
    fontFamily: 'Futura Std Extra Bold Condensed',
    fontWeight: 900,
    borderRadius: '15px 0px 0px 15px'
};
var landscapeTagContainerStyles = {
    position: 'absolute',
    right: '150px',
    top: '0px',
    fontSize: '30px',
    color: 'white',
    zIndex: 5,
    padding: '15px 40px 5px',
    fontFamily: 'Futura Std Extra Bold Condensed',
    fontWeight: 900,
    borderRadius: '0px 0px 15px 15px'
};
var generatePortraitTag = function (tag, fillColor) { return (react_1.default.createElement("div", { style: __assign(__assign({}, portratTagContainerStyles), { backgroundColor: fillColor, color: tag === seesignage_utils_1.ProductTags.new ? 'black' : 'white' }) }, i18n_1.default
    .t("product.tag.".concat(tag))
    .toUpperCase()
    .split('')
    .map(function (c, i) { return (react_1.default.createElement("div", { key: "".concat(i, "-").concat(c) }, c)); }))); };
var generateLandscapeTag = function (tag, fillColor, customStyles) { return (react_1.default.createElement("div", { style: __assign(__assign(__assign({}, landscapeTagContainerStyles), { backgroundColor: fillColor, color: tag === seesignage_utils_1.ProductTags.new ? 'black' : 'white' }), customStyles) },
    i18n_1.default.t("product.tag.".concat(tag)).toUpperCase(),
    tag === seesignage_utils_1.ProductTags.new && "!")); };
var generateSokTagSvg = function (_a) {
    var itemsCount = _a.itemsCount, fillColor = _a.fillColor, tag = _a.tag;
    if (itemsCount === 1) {
        return generateLandscapeTag(tag, fillColor, { fontSize: '60px', right: '200px' });
    }
    if (itemsCount === 2) {
        return generateLandscapeTag(tag, fillColor, { fontSize: '45px', right: '150px' });
    }
    if (itemsCount === 3 || itemsCount === 4) {
        return generateLandscapeTag(tag, fillColor, { fontSize: '40px', right: '100px' });
    }
    if (itemsCount >= 5 && itemsCount <= 8) {
        return generatePortraitTag(tag, fillColor);
    }
};
exports.generateSokTagSvg = generateSokTagSvg;
//# sourceMappingURL=tags.js.map